import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useRoutes } from "react-router-dom";
import ConsultationManagement from "../clinique/ConsultationManagement";
import ConsultationsHistory from "../clinique/ConsultationsHistory";
import DashboardLayoutBranding from "../clinique/DashboardLayoutBranding";
import DataGridPersonnel from "../clinique/DataGridAgent";
import IdentificationAssure from "../clinique/IdentificationAssure/IdentificationAssure";
import ConnectedAgentProfilePage from "../clinique/pages/ConnectedAgentProfile";
import PrescriptionsHistory from "../clinique/PrescriptionsHistory";
import ReceptionsHistory from "../clinique/ReceptionsHistory";
import useAuthStore from "../store/authStore";
const AdminChildren = [
  { index: true, element: <DataGridPersonnel /> },
  { path: "personnel", element: <DataGridPersonnel /> },
  { path: "profile", element: <ConnectedAgentProfilePage /> },
  { path: "consultation", element: <ConsultationManagement /> },
];

const AgentChildren = [
  { index: true, element: <IdentificationAssure /> },
  { path: "Reception", element: <ReceptionsHistory /> },
  { path: "rendez-vous", element: <div>Gestion des Rendez-vous</div> },
];

const MedecinChildren = [
  { index: true, element: <ReceptionsHistory /> },
  { path: "patients", element: <div>Liste des Patients</div> },
  { path: "prescription", element: <PrescriptionsHistory /> },
  { path: "consultations", element: <ConsultationsHistory /> },
  { path: "reception", element: <ReceptionsHistory /> }, // Fixed duplicate "consultations"
  { path: "consultation", element: <ConsultationManagement /> },
];

const DynamicRoutes = () => {
  const user = useAuthStore((state) => state.user);

  const routes = React.useMemo(() => {
    switch (user?.role) {
      case "admin_clinique":
        return AdminChildren;
      case "agent_clinique":
        return AgentChildren;
      case "medecin_clinique":
        return MedecinChildren;
      default:
        return [];
    }
  }, [user?.role]);

  return useRoutes(routes);
};

const LoadingWrapper = ({ children }) => {
  const user = useAuthStore((state) => state.user);

  if (!user?.role) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return children;
};

const CliniqueRoutes = [
  {
    path: "*",
    element: (
      <LoadingWrapper>
        <DashboardLayoutBranding>
          <DynamicRoutes />
        </DashboardLayoutBranding>
      </LoadingWrapper>
    ),
  },
];

export default CliniqueRoutes;
